module.exports = __webpack_public_path__ + "f63ad3e25ec3bdcd1e20c6632eeb5c25.jpg";